import React, { PureComponent } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton,
  SIZE,
  ROLE
} from "baseui/modal";

export default class CodeModal extends PureComponent {
  constructor(props) {
    super(props);
    this.textAreaREF = React.createRef();
    this.state = {};
  }

  componentWillUnmount() {}

  _handleCopy() {
    this.textAreaREF.current.select();
    document.execCommand("copy");
  }

  render() {
    const { isOpen, onModalClose } = this.props;
    return (
      <div className="code-modal">
        <Modal
          onClose={onModalClose}
          closeable
          isOpen={isOpen}
          animate
          autoFocus
          size={SIZE.default}
          role={ROLE.dialog}
        >
          <ModalHeader>Embed The Power Outage Map</ModalHeader>
          <ModalBody>
            <textarea
              class="modal-textarea"
              rows="1"
              autocomplete="off"
              placeholder=""
              aria-describedby=""
              aria-labelledby="embed code"
              ref={this.textAreaREF}
              value={`<div id="bloom-map-iframe21" style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; "><style type="text/css" >@media (max-width: 800px){#bloom-map-iframe21{padding-bottom:111.25% !important}}</style><iframe frameborder='0' width="560" height="315" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border:0;" src="https://bloom-outages-map.firebaseapp.com?embed=true" frameborder="0" allowfullscreen></iframe></div>`}
            ></textarea>
          </ModalBody>
          <ModalFooter>
            <div class="modal-footer-grid-container">
              <div class="copy">
                <p className="modal-sub-text">
                  By embedding this map on your site, you agree to give credit
                  to Bloom Energy.
                </p>
              </div>
              <div class="button">
                <ModalButton
                  onClick={this._handleCopy.bind(this)}
                  overrides={{
                    BaseButton: {
                      style: ({ $theme }) => {
                        return {
                          backgroundColor: "#4F9F43"
                        };
                      }
                    }
                  }}
                >
                  Copy
                </ModalButton>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
